import { courseCardsSection } from "../../models/page-builder/course-card-section.modal";

export const MOCK_COURSE_CARDS_SECTION: courseCardsSection = {
  type: "course-cards",
  content: {
    headings: {
      title: "Featured Courses",
      titleColor: "#333",
      subTitle: "Check out our top picks",
      subTitleColor: "#666",
    },
    courses: [],
    buttons: {
      items: [
        {
          buttonLink: "https://www.facebook.com/",
          buttonText: "View All",
          textColor: "#fff",
          backgroundColor: "#ff9900",
          borderColor: "#fff",
        },
        {
          buttonLink: "https://www.facebook.com/",
          buttonText: "Enroll Now",
          textColor: "#fff",
          backgroundColor: "#ff9900",
          borderColor: "#fff",
        },
      ],
    },
  },
  design: {
    headingAlignment: "left",
    appearance: {
      cardBgColor: "#fff",
      pageBgcolor: "#f5f5f5",
      courseTitleColor: "#333",
      courseDesColor: "#666",
      courseDetailsColor: "#999",
      coursePriceColor: "#ff9900",
      DiscountPriceColor: "#cc0000",
      priceTagBG: "#e6e6e6",
    },
  },
};
